import React, { Component } from 'react';
import { getText } from '../config';

class OriginFlights extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fixedHeight: null
        }
    }

    setFixedHeight() {
        this.setState({
            fixedHeight: document.documentElement.clientHeight
        })
    }

    removeFixedHeight() {
        this.setState({
            fixedHeight: null
        })
    }

    render() {
        return (
            <div className="destinations" style={this.state.fixedHeight ? {height: this.state.fixedHeight} : {}}>
                <div className={"destinations-header" + (this.props.withMargin ? ' with-margin' : '')}>
                    <span>{getText('selectDeparture')}</span>
                    <input
                        className="input"
                        type="text"
                        onFocus={this.setFixedHeight.bind(this)}
                        onBlur={this.removeFixedHeight.bind(this)}
                        onChange={this.props.onDestinationInput}
                        placeholder={this.props.origin || this.props.placeholderText} />
                </div>
                {!this.props.originInput && <div className="destinations-favorites">{getText('bestDestinations')}</div>}
                {this.props.originInput && this.props.origins.length === 0 && this.props.searchType === 'hotel' && <div className="destinations-favorites">{getText('noDestination')}</div>}
                <ul className="destinations-list">
                    {this.props.origins.map((origin) => {
                        if(this.props.originInput) {
                            const startMatch = origin.label.toLowerCase().indexOf(this.props.originInput.toLowerCase());
                            const endMatch = this.props.originInput.length + startMatch;
                            return (
                                <li
                                    onClick={this.props.selectOrigin.bind(null, origin)}
                                    key={origin.value}
                                    className={this.props.origin === origin.label ? "selected" : ""}>
                                    <span>{origin.label.substring(0, startMatch)}</span>
                                    <span
                                        className={this.props.origin === origin.label ? "" : "destinations-list-match"}>{origin.label.substring(startMatch, endMatch)}</span>
                                    <span>{origin.label.substring(endMatch)}</span>
                                </li>
                            )
                        } else {
                            return (
                                <li
                                    onClick={this.props.selectOrigin.bind(null, origin)}
                                    key={origin.value}
                                    className={this.props.origin === origin.label ? "selected" : ""}>
                                    <span>{origin.label}</span>
                                </li>
                            )
                        }
                    })}
                </ul>
            </div>
        );
    }
}

OriginFlights.propTypes = {
    //myProp: PropTypes.type.isRequired
};

export default OriginFlights;


// WEBPACK FOOTER //
// ./src/components/OriginFlights.js